import nkpsimsLogo from "../assets/icons/nkps-l1.png";
import rsanLogo from "../assets/icons/nkps-l2.png";

export interface Org {
  short: string;
  name: string;
  subtitle: string;
  logo: string;
}

export type OrgKey = "rsan" | "nkpsims";

export const ORGS: Record<OrgKey, Org> = {
  rsan: {
    short: "RSAN",
    name: "Radiology Skill Academy",
    subtitle: "NKPSIMS, Nagpur",
    logo: rsanLogo,
  },
  nkpsims: {
    short: "NKPSIMS",
    name: "N.K.P. Salve Institute of Medical Sciences & Research Centre",
    subtitle: "Lata Mangeshkar Hospital, Nagpur",
    logo: nkpsimsLogo,
  },
};

const primary = ORGS.rsan;
const secondary = ORGS.nkpsims;

export const SUPPORT = {
  name: "Vaibhav Jain",
  phone: "9822366585",
  email: "rsankpsims@gmail.com",
};

export type FeatureIcon = "award" | "shield" | "book" | "users";

export interface Feature {
  icon: FeatureIcon;
  title: string;
  sub: string;
}

export const BRAND = {
  primary,
  secondary,
  logos: [primary, secondary],
  appName: `${primary.short} Exam Portal`,
  appShortName: primary.short,
  badge: "Certifications & Examinations",
  headline: { lead: "Advance Your", highlight: "Radiology Career" },
  description:
    "Join the nation's premier platform for medical imaging certifications, trusted by thousands of radiology professionals.",
  instituteMeta: "Nagpur, Maharashtra · NAAC Accredited",
  support: SUPPORT,
  copyright: `© ${new Date().getFullYear()} ${primary.short} – ${primary.name}. All rights reserved.`,
  copyrightSub: `${secondary.name}, Nagpur.`,
};

export default BRAND;
